import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';
import { CalculatorProvider } from './config/calculatorContext.config';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CalculatorProvider>
    <ToastContainer />
      <App />
  </CalculatorProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
